import React from 'react';
import { BRAND_NAME } from '../brand';

interface LogoProps {
    className?: string;
    size?: number;
    color?: string;
    variant?: 'symbol' | 'wordmark';
    appearance?: 'auto' | 'light' | 'dark';
}

// `color` remains accepted for existing callers; the approved artwork keeps its own colors.
export const Logo: React.FC<LogoProps> = ({ className, size = 32, variant = 'symbol', appearance = 'auto' }) => {
    const base = `${process.env.PUBLIC_URL || ''}/brand`;
    const wordmark = variant === 'wordmark';
    const cut = size < 24 ? 'micro' : size < 48 ? 'small' : 'full';
    const lightAsset = wordmark ? 'kurrate-wordmark-light.svg'
        : cut === 'micro' ? 'favicon-micro.svg'
        : cut === 'small' ? 'kurrate-symbol-small.svg' : 'kurrate-symbol-light.svg';
    const darkAsset = wordmark ? 'kurrate-wordmark-dark.svg'
        : cut === 'micro' ? 'favicon-micro.svg'
        : cut === 'small' ? 'kurrate-symbol-small-dark.svg' : 'kurrate-symbol-dark.svg';
    const width = wordmark ? Math.max(80, size * 3.7) : size;
    return (
        <span
            role="img"
            aria-label={BRAND_NAME}
            data-brand-variant={variant}
            data-brand-appearance={appearance}
            className={`kurrate-logo${className ? ` ${className}` : ''}`}
            style={{ width, height: size }}
        >
            <img className="kurrate-logo-on-light" src={`${base}/${lightAsset}`} width={width} height={size} alt="" aria-hidden="true" />
            <img className="kurrate-logo-on-dark" src={`${base}/${darkAsset}`} width={width} height={size} alt="" aria-hidden="true" />
        </span>
    );
};

export default Logo;
